import { useMemo } from "react"
import keyBy from "lodash.keyby"

import api from "@api"
import { useStore } from "@stores"
import hasAccess from "@api/hasAccess"
import { useAppContext } from "@components/AppContext"

export const indexOperation = api.get("transactions/IndexBankAccounts")


const useBankAccountsStore = (projects) => {
  const { request, identity } = useAppContext()
  const { id: organizationId } = identity.organization

  const canReadBankAccounts = hasAccess(["bank-accounts-read"])
  const shouldAutoLoad = canReadBankAccounts

  const { items: bankAccounts } = useStore(indexOperation.id, request, shouldAutoLoad, {}, [ organizationId ])

  const bankAccountsMap = useMemo(() =>
    keyBy(bankAccounts, "id")
  , [ bankAccounts ])

  const getBankAccount = id => bankAccountsMap[id]

  const isInvalidBankAccount = id => {
    const bankAccount = getBankAccount(id)

    if (!bankAccount) {
      return false
    }

    return bankAccount.isInvalid
  }

  const getBankAccountName = id => {
    const bankAccount = getBankAccount(id)

    if (!bankAccount) {
      return id
    }

    const { beneficiaryName, sourceName } = bankAccount

    return `${beneficiaryName} - ${sourceName}`
  }

  const isInvalidBankAccountTransaction = transaction => {
    const {
      projectId,
      senderSourceId,
      receiverSourceId,
    } = transaction

    const project = projects.find(({ id }) => id === projectId)
    const { bankAccountId: fundingBankAccountId, distributionBankAccountId } = project

    const fundingBankAccount = bankAccountsMap[fundingBankAccountId]
    const distributionBankAccount = bankAccountsMap[distributionBankAccountId]

    const bankAccountsBySourceIdMap = keyBy([ fundingBankAccount, distributionBankAccount ], 'sourceId')

    const bankAccount =
      bankAccountsBySourceIdMap[senderSourceId] ||
      bankAccountsBySourceIdMap[receiverSourceId]

    if (!bankAccount) {
      return false
    }

    const { isInvalid } = bankAccount

    return isInvalid
  }

  return {
    bankAccounts,
    bankAccountsMap,
    getBankAccountName,
    isInvalidBankAccount,
    isInvalidBankAccountTransaction
  }
}

export default useBankAccountsStore
